export const LOCALES = {
  PT_BR: 'pt-BR',
};

export const FORMATS = {
  [LOCALES.PT_BR]: {
    number: {
      currency: {
        style: 'currency',
        currency: 'BRL',
      },
    },
  },
};
